<template>
  <div>
    <template v-if="case_">
      <div class="panel wraper" :class="statusClass">
        <div class="panel-header">
          <transition :name="transName || 'slide-l'" mode="out-in">
            <div class="panel-title" :key="$route.params.id">
              <span v-if="$route.name==='instrumentCaseView'">Кейс № {{case_.label}}</span>
              <unit-path v-else :id="case_.parent_id" :lbl="'Кейс № ' + case_.label"></unit-path>
            </div>
          </transition>
        </div>
        <transition :name="transName || 'slide-l'" mode="out-in">
          <div class="panel-body" :key="$route.params.id">
            <p v-if="case_.lastEdited" class="in-top">
              <small class="view-label">
                <q-icon name="fas fa-user-edit"/> {{editor}} {{case_.lastEdited | formatTime}}
              </small>
            </p>
            <p>
              <span class="text-bolder">{{case_.statusLabel}}&nbsp;{{workDateLabel}}</span>
            </p>
            <p v-if="case_.problem">
              <small class="view-label">Проблема</small>
              <span class="text-bolder">{{case_.problem}}</span>
            </p>
            <p v-if="case_.master">
              <small class="view-label">Исполнитель</small>
              <span class="text-bolder">{{masterName}}</span>
            </p>
            <p v-if="case_.result">
              <small class="view-label">Результат</small>
              <span class="text-bolder">{{case_.result}}</span>
            </p>
            <request-card v-if="case_.raw" :request="case_.raw"></request-card>
            <media-bar :medias="mediasCopy" @selectMedia="showAttach"></media-bar>
            <p class="subtitle" v-if="case_.works">
              Работы ({{case_.works.length}})
            </p>
            <div class="panel-list">
              <work-item :item="item" v-for="(item, ind) in sortedWorks" :key="ind"></work-item>
            </div>
          </div>
        </transition>
      </div>
      <pop-btn v-if="notReader" class="mobile-hide" :btns="btns"/>
      <pop-hold v-if="notReader" class="mobile-only" :btns="btns"/>
      <media-modal :done="createAttach" ref="mediaModal"/>
    </template>
    <template v-else>
      <div>
        <spinner name="dots"></spinner>
      </div>
    </template>
    <mediator
        :editEnabled="notReader"
        ref="mediator"
        @mediaEdited="mediaEdited"
        @mediaDeleted="mediaDeleted"
        @doNext="doNext"
    />
  </div>
</template>


<script>
import CaseItem from './case-item.vue';
import WorkItem from './work-item.vue';
import UnitPath from './unit-path.vue';
import viewCommon from './view-common.js';
import PopBtn from 'components/pop-btn.vue';
import PopHold from 'components/pop-hold.vue';
import MediaModal from './media-modal.vue';
import Mediator from './mediator.vue';
import MediaBar from './media-bar.vue';
import RequestCard from './request-card.vue';
import _ from 'lodash';

export default {
  name: 'caseview',
  props: ['transName'],
  components: {
    caseItem: CaseItem,
    workItem: WorkItem,
    unitPath: UnitPath,
    requestCard: RequestCard,
    PopBtn,
    PopHold,
    MediaModal,
    Mediator,
    MediaBar,
  },
  extends: viewCommon,
  data() {
    return {};
  },
  mounted() {
    this.$watch('case_', (a) => {
      document.title = `Кейс ${a.label}`;
    }, {
      immediate: true,
    });
    this.$watch('$route.query.mid', (val) => {
      console.log('HANDLER //////////////////////', val, '//', this.mediasCopy.length);
      if (val && this.mediasCopy[0]) {
        const ind = this.mediasCopy.findIndex(item => item.id === val);
        if (ind > -1) {
          this.showAttach(this.mediasCopy[ind]);
          this.$router.replace({ query: {} }); // remove query
        }
      }
    }, {
      immediate: true,
    });
  },
  computed: {
    instrumentId() {
      return this.$route.name === 'instrumentCaseView' ? this.$route.params.iid : null;
    },
    mediasCopy() {
      return this.case_.medias ?
        this.case_.medias.map(media => Object.assign({}, media))
        :
        [];
    },
    btns() {
      return [
        {
          color: 'warning',
          click: this.goEdit,
          icon: 'create',
          tooltip: 'Изменить',
          hide: !this.editEnabled,
        },
        {
          color: 'positive',
          icon: 'fa-paperclip',
          tooltip: 'Добавить вложение',
          prefix: '+',
          click: this.chooseMedia,
        },
        {
          color: 'positive',
          click: this.doAddCase,
          icon: 'fa-briefcase',
          tooltip: 'Новый кейс',
          hide: !this.showCaseButton,
        },
        {
          color: 'positive',
          click: this.doCut,
          icon: 'file_upload',
          tooltip: 'Выбрать для перемещения',
          hide: !this.isAdmin,
        },
        {
          color: 'negative',
          click: this.doDelete,
          icon: 'delete_forever',
          tooltip: 'Удалить',
          hide: !this.isAdmin,
        },
      ];
    },
    showCaseButton() {
      return this.isDispatcher && this.instrumentId &&
          !this.$store.state.rightVisible;
    },
    engineers() {
      return this.$store.getters.engineers;
    },
    masterName() {
      if (this.case_.master) {
        const he = this.engineers.find(item => item.value === this.case_.master, this);
        return he ? he.label : '???????????';
      }
      return '';
    },
    // only dispatcher or case master can edit
    editEnabled() {
      return this.isDispatcher || (this.case_.master === this.$store.state.user.roles[0]);
    },
    editor() {
      return this.$store.getters.userScreenName(this.case_.editedBy);
    },
    statusClass() {
      return this.$utils.statusClass(this.case_.status, this.case_.workDate);
    },
    case_() {
      return this.$store.state.cases[this.id];
    },
    pid() {
      return this.case_.parent_id;
    },
    workDateLabel() {
      if (this.case_.workDate) {
        const d = new Date(this.case_.workDate);
        return d.toLocaleDateString('ru');
      }
      return '';
    },
    sortedWorks() {
      const works = _.cloneDeep(this.case_.works);
      if (!_.isEmpty(works)) {
        works.sort((a, b) => b.msDate - a.msDate);
      }
      return works;
    },
  },
  methods: {
    doDelete() {
      this.$q.dialog({
        title: 'Подтвердите удаление',
        'prevent-close': true,
        message: `${this.case_.label} будет безвозвратно удален!`,
        ok: {
          flat: true,
          color: 'negative',
          label: 'Удалить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => this.$store.dispatch('deleteUnit', this.case_))
        .then(() => {
          if (this.$route.name === 'instrumentCaseView') {
            this.$router.push(`/list/${this.pid}`);
          } else {
            this.$router.push(this.$route.path.slice(0, this.$route.path.lastIndexOf('/'))); // cut last segment
          }
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    },
    doCut() {
      this.$store.dispatch('placeToBuffer', { id: this.id, parent_id: this.pid });
    },
    doAddCase() {
      this.$router.push(`/icnew/${this.instrumentId}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/case-view.vue